// export const API_URL = "http://4.213.224.148:8084/";
export const API_URL = "https://cagapi.aibott.org/";
export const CHAT_URL = "https://bashini.aibott.org/";
// export const API_URL = "https://upcmhelpline.aibott.org/backend1/";
// export const API_URL = "http://4.213.224.148:8086/";
// export const AUTH_URL = "http://4.213.224.148:5002/";
export const AUTH_URL = "https://cagapi.aibott.org/";
// export const AUTH_URL = "https://upcmhelpline.aibott.org/backend/";
// export const AUTH_URL = "http://4.213.224.148:6001/";
export const OCR_URL = "https://ocr-tech.aibott.org/";
